import React from "react";
import './search-home-block.css';

const SearchHomeBlock = ({...props}) => {
  const { text, img, title, link } = props;

  return <a href={link} target="_blank" rel="noopener noreferrer" className="search-home-block">
    <img src={img} alt="" className="search-home-block-icon" />
    <div className="search-home-col">
      <div className="search-home-block-title">{title}</div>
      {text && <div className="search-home-block-text">{text}</div>}
    </div>
  </a>
}

export default SearchHomeBlock;
